import {Directive, HostListener} from '@angular/core';
import {NgControl} from '@angular/forms';

@Directive({
  selector: '[digitoVerificadorMask]'
})
export class DigitoVerificadorMaskDirective {

  constructor(private ngControl: NgControl) {}

  @HostListener('input', ['$event'])
  onInput(event: any) {
    let value = event.target.value || '';

    value = value.replace(/\D/g, '');
    if (value.length > 2) {
      value = value.substring(0, 2);
    }
    // Aplica máscara: 00
    value = value.replace(/\D/g, '').slice(0, 2);

    this.ngControl.control.setValue(value, { emitEvent: false });
  }
}
